<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        fab
        title="Add New Fund Bucket Has Type"
        v-on="on"
      >
        <v-icon medium>
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Fund Bucket Has Type
            </h4>
            <p class="category font-weight-thin">
              Create Fund Bucket Has Type
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form
        v-if="dialog && !loading"
      >
        <v-container>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="schema"
                v-validate="'required'"
                item-text="name"
                :items="schemas"
                label="Schema"
                :error-messages="errors.collect('schema')"
                data-vv-name="schema" 
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="bucket"
                v-validate="'required'"
                item-text="fund_bucket.name"
                item-value="fund_bucket.id"
                :items="filteredBucketTypes"
                label="Fund Bucket"
                :error-messages="errors.collect('bucket')"
                data-vv-name="bucket" 
                data-vv-as="Fund Bucket"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="type"
                v-validate="'required'"
                item-text="name"
                item-value="id"
                :items="fundBucketTypes"
                label="Fund Bucket Type"
                :error-messages="errors.collect('type')"
                data-vv-name="type"
                data-vv-as="Fund Bucket Type"
              />
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
            
        schemas: [],
        fundBuckets: [],
        fundBucketTypes: [],

        schema: '',
        bucket: '',
        type: '',
      }
    },
    computed: {
      filteredBucketTypes () {
        if (!this.schema) return
        
        return this.fundBuckets.filter(fundBucket => {
          return fundBucket.schema_name === this.schema
        })
      },
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        } else {
          this.loadData() 
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true
        Promise.all([
          this.$api.companies().withSchema(),
          this.$api.fundBucketHasTypes().list(),
          this.$api.fundBucketTypes().list(),
        ])
          .then(([schemas, fundBuckets, fundBucketTypes]) => {
            schemas.data.map(item => {
              this.schemas.push(item.schema_name)
            })
            this.fundBuckets = fundBuckets.data
            this.fundBucketTypes = fundBucketTypes.data
            this.loading = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.fundBucketHasTypes().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 201) {
                  this.$emit('created')
                  this.$snack({ color: 'success', message: response.data.message })

                  this.dialog = false
                }
              }).catch(err => {
                this.$snack({ color: 'error', message: err.response.statusText })
              }).then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          schema_name: this.schema,
          bucket_id: this.bucket,
          type_id: this.type,
        }
      },
    },
  }
</script>
